export { default } from './DetailsAndPricing';
